const translations = {
  en: {
    dashboardTitle: 'Dashboard',
    status: 'Status',
    expired: 'Expired',
    trial: 'Trial',
    trialEndsIn: 'Trial ends in',
    view: 'View',
    activate: 'Activate',
    active: 'Active',
    plan: 'Plan',
    updateHashtag: 'Update #Hashtag',
    copyShare: 'Copy & Share',
    edit: 'Edit',
    editingDisabled: 'Editing is disabled after wedding date',
    rsvp: 'RSVP',
    music: 'Music',
    designs: 'Designs',
    gallery: 'Gallery',
    saveAsPdf: 'Save as PDF',
    wishlist: 'Wishlist',
    moneyGift: 'MoneyGift',
    downloadInvitation: 'Download Invitation',
    weddingPlanner: 'Wedding Planner',
    cannotEditAfterEvent: 'Cannot edit after event',
    enterHashtag: 'Enter hashtag',
    textCopied: 'Text copied to clipboard!',
    hashtagUpdated: 'Hashtag updated',
    activateRsvp: 'Activate RSVP?',
    needGuestEmail: 'Need guest email?',
    deleteRsvpConfirmation: 'Delete {name} from RSVP list?',
    phone: 'Phone:',
    email: 'Email:',
    guests: 'Guests:',
    wishes: 'Wishes:',
    checkAttend: 'Check Attend',
    attended: 'Attended',
    delete: 'Delete',
    listOfRsvps: 'List of RSVPs',
    searchByNameOrPhone: 'Search by name or phone number',
    attending: 'Attending',
    totalGuests: 'Total guests:',
    notAttending: 'Not attending',
    noRsvpsSubmitted: 'No RSVPs submitted yet.',
    enableBackgroundMusic: 'Enable Background Music?',
    useThis: 'Use This',
    enterYoutubeLink: 'Enter YouTube video link',
    play: 'Play',
    startAt: 'Start at',
    ourSuggestions: 'Our Suggestions:',
    aThousandYears: 'A Thousand Years',
    beautifulInWhite: 'Beautiful in White',
    perfect: 'Perfect',
    youAreTheReason: 'You Are The Reason',
    backgroundMusic: 'Background Music',
    copyPasteYoutubeLink: 'Copy YouTube video link and paste it on the form below:',
    useThisDesign: 'Use this design?',
    designUpdatedSuccessfully: 'Design updated successfully',
    failedToUpdateDesign: 'Failed to update design',
    errorUpdatingDesign: 'Error updating the design',
    currentDesign: 'Current Design',
    selectDesigns: 'Select Designs',
    preview: 'Preview',
    select: 'Select',
    changeDesign: 'Change Design',
    deletePhotoConfirmation: 'Are you sure you want to delete this photo?',
    photoDeletedSuccessfully: 'Photo deleted successfully',
    errorDeletingPhoto: 'Error deleting photo. Please try again.',
    selectFilesFirst: 'Please select files first',
    cardIdNotAvailable: 'Card ID is not available',
    wpCredentialsNotConfigured: 'WordPress credentials are not configured',
    successfullyUploadedPhotos: 'Successfully uploaded {count} photos!',
    errorUploadingPhotos: 'Error uploading photos. Please try again.',
    photoSelected: '{count} photo selected',
    photosSelected: '{count} photos selected',
    dropPhotosHere: 'Drop photos here or click to upload',
    clickToUpload: 'Click upload button below to start uploading',
    fileTypes: 'PNG, JPG, GIF up to 10MB',
    uploading: 'Uploading {current}/{total} ({percent}%)',
    uploadPhotos: 'Upload Photos',
    uploadedPhotos: 'Uploaded Photos',
    loadingPhotos: 'Loading photos...',
    noPhotosUploaded: 'No photos uploaded yet',
    deletePhoto: 'Delete photo',
    photoGallery: 'Photo Gallery',
    page1: 'Page 1',
    page2: 'Page 2',
    youHaveNoAccess: 'You have no access to this page.',
    itemTitle: 'Item Title',
    enterTitle: 'Enter title',
    itemUrlOptional: 'Item URL (optional)',
    enterUrl: 'Enter URL',
    uploadImageOptional: 'Upload Image (optional)',
    saving: 'Saving...',
    saveWishlist: 'Save Wishlist',
    deleteItemConfirmation: 'Are you sure you want to delete this item?',
    loadingWishlist: 'Loading wishlist...',
    noWishlistItems: 'No wishlist items added yet.',
    clickAddWishlist: 'Click "Add Wishlist" to add your first item.',
    title: 'Title',
    urlOptional: 'URL (optional)',
    save: 'Save',
    cancel: 'Cancel',
    viewItem: 'View item',
    myWishlist: 'My Wishlist',
    addWishlist: 'Add Wishlist',
    backToWishlist: '← Back to Wishlist',
    deleteInfoConfirmation: 'Are you sure you want to delete this info?',
    manageMoneyGift: 'Manage Money Gift',
    bankName: 'Bank Name:',
    accountNumber: 'Account Number:',
    receiverName: 'Receiver Name:',
    update: 'Update',
    bankNameLabel: 'Bank Name',
    bankNamePlaceholder: 'e.g. Deutsche Bank, Sparkasse, N26',
    accountNumberLabel: 'Account Number',
    accountNumberPlaceholder: 'e.g. IBAN: DE89 3704 0044 0532 0130 00',
    receiverNameLabel: 'Receiver Name',
    receiverNamePlaceholder: 'e.g. Max Mustermann',
    downloadWeddingMemories: 'Download Your Wedding Memories',
    downloadDescription: 'Click the button below to generate and download your photo gallery and guest wishes in a beautiful PDF format.',
    downloadPdf: 'Download PDF',
    preparing: 'Preparing...',
    photoMemories: 'Photo Memories',
    guestWishes: 'Guest Wishes',
    preparingCoverPage: 'Preparing cover page...',
    croppingGalleryImage: 'Cropping gallery image {i} of {total}',
    processingWishesPage: 'Processing wishes page {chunkIndex} of {total}',
    finalizing: 'Finalizing...',
    done: 'Done',
    logout: 'Logout',
    yourWeddingRsvp: 'Your Wedding RSVP',
    id: 'ID:',
    access: 'Access',
    editTitle: 'Edit',
    leaveWarning: 'Are you sure you want to leave? Changes you made may not be saved.',
    clickToChangeName: 'Click to change name',
    ok: 'OK',
    changeDate: 'Change date',
    location: 'Location',
    clickToEditLocation: 'Click to edit location',
    date: 'Date',
    time: 'Time',
    changeTime: 'Change Time',
    schedule: 'Schedule',
    newItem: 'New Item',
    save: 'Save',
    changeSchedule: 'Change Schedule',
    countdown: 'Countdown',
    days: 'Day/s',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    clickToAddContacts: 'Click here to add contacts',
    clickToChangeWeddingVenue: 'Click to change wedding venue',
    update: 'Update',
    addCoordinatesFormat: 'Add coordinates with following format: 3.XXXXXX,101.XXXXXX',
    step1: 'Step 1:',
    clickButtonToGetCoordinate: 'Click button below to get location coordinate',
    clickHere: 'Click Here',
    step2: 'Step 2:',
    locationName: 'Location Name:',
    locationNamePlaceholder: 'eg: Daun Grand Hall, The Icon, 6th Floor',
    coordinate: 'Coordinate:',
    coordinatePlaceholder: 'eg: 3.156525,101.722336',
    updateLocation: 'Update Location',
    addLocation: 'Add Location',
    previewTitle: 'Preview',
    next: 'Next',
    demoContactsMessage: 'This is just an example. Click "Next" to add contacts.',
    addContactsTitle: 'Add Contacts',
    addContactsDescription: 'Add your Wedding Person In Charge contact number',
    name: 'Name:',
    phoneNumber: 'Phone Number:',
    whatsapp: 'WhatsApp',
    phoneCall: 'Phone Call',
    both: 'Both',
    addContact: 'Add Contact',
    submit: 'Submit',
    signUpTitle: 'Sign Up',
    confirmYourEmail: 'Confirm your email',
    enterOtpSentTo: 'Enter 6 digit OTP sent to your email:',
    changeEmail: 'Change email? Click Here',
    otp: 'OTP:',
    otpPlaceholder: 'XXXXXX',
    incorrectOtp: 'Incorrect OTP. Try again!',
    confirm: 'Confirm',
    resendOtp: 'Resend OTP',
    resendOtpWithCountdown: 'Resend OTP ({countdown})',
    signUpDescription: 'Enter your email address to create an account',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    signUpButton: 'Sign Up',
    profileTitle: 'Profile',
    completeYourProfile: 'Complete your profile',
    enterYourFullName: 'Enter your full name',
    pleaseEnterYourFullName: 'Please enter your full name',
    pleaseEnterYourPhoneNumber: 'Please enter your phone number',
    pleaseEnterYourEmail: 'Please enter your email',
    submit: 'Submit',
    selectPlanTitle: 'Select Plan',
    failedToLoadPackages: 'Failed to load packages.',
    unlimitedDesigns: 'Unlimited Designs',
    backgroundMusic: 'Background Music',
    oneClickCallWhatsapp: 'One-click Call/WhatsApp',
    oneClickWazeGoogleMaps: 'One-click Waze/Google Maps',
    countdown: 'Countdown',
    rsvp: 'RSVP',
    guestbook: 'Guestbook',
    photoGallery: 'Photo Gallery',
    pdf: 'PDF',
    select: 'Select',
    checkoutTitle: 'Checkout',
    productSummary: 'Product Summary',
    plan: 'Plan:',
    price: 'Price:',
    billingInformation: 'Billing Information',
    enterYourName: 'Enter your name',
    pleaseEnterYourName: 'Enter your name',
    enterYourPhoneNumber: 'Enter your phone number',
    pleaseEnterYourPhoneNumber: 'Enter your phone number',
    enterYourEmail: 'Enter your email',
    promoCode: 'Promo Code',
    enterPromoCode: 'Enter promo code',
    apply: 'Apply',
    promoCodeAppliedSuccessfully: 'Promo code applied successfully!',
    promoCodeFullyClaimed: 'This promo code has fully claimed. Please try a different one.',
    promoCodeExpired: 'This promo code has expired. Please try a different one.',
    invalidPromoCode: 'Invalid promo code. Please try again.',
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal:',
    discount: 'Discount:',
    total: 'Total:',
    processing: 'Processing...',
    activate: 'Activate',
    buyNow: 'Buy Now',
    failedToCreateOrder: 'Failed to create order. Please try again.',
    weInviteYou: 'We Invite You To Celebrate Our Wedding',
    tempat: 'Location',
    tarikh: 'Date',
    masa: 'Time',
    hari: 'Days',
    jam: 'Hours',
    minit: 'Minutes',
    saat: 'Seconds',
    selectState: 'Select State',
    dragMapInstruction: 'Drag the map to position the pin at your desired location',
    searchLocation: 'Search Location',
    venueName: 'Venue Name *',
    streetAddress: 'Street Address *',
    city: 'City *',
    postcode: 'Postcode *',
    state: 'State *',
    updateLocation: 'Update Location',
    geolocationNotSupported: 'Geolocation is not supported by this browser.',
    allowLocationAccess: 'Please allow location access and try again.',
    locationUnavailable: 'Location information is unavailable.',
    locationTimeout: 'Location request timed out.',
    unknownError: 'An unknown error occurred.',
    googleMapsFailed: 'Google Maps failed to load. Please refresh the page.',
    unableToFindCoordinates: 'Unable to find location coordinates. Please try a different search.',
    failedToInitializeSearch: 'Failed to initialize location search. Please try again.',
    loadingGoogleMaps: 'Loading Google Maps...',
    useCurrentLocation: 'Use my current location',
    enterVenueName: 'Enter venue name',
    enterStreetAddress: 'Enter your street address',
    cityPlaceholder: 'City',
    postcodePlaceholder: '12345',
    malaysia: 'Malaysia',
    currentLocationPrefix: 'Current Location: ',
    selectedLocationPrefix: 'Selected Location: ',
    unableToGetCurrentLocation: 'Unable to get your current location. ',
    money_gift: 'Money Gift',
    wishlist: 'Wishlist',
    download: 'Download',
    planner: 'Planner',
  },
  es: {
    dashboardTitle: 'Panel',
    status: 'Estado',
    expired: 'Expirado',
    trial: 'Prueba',
    trialEndsIn: 'La prueba termina en',
    view: 'Ver',
    activate: 'Activar',
    active: 'Activo',
    plan: 'Plan',
    updateHashtag: 'Actualizar #Hashtag',
    copyShare: 'Copiar y Compartir',
    edit: 'Editar',
    editingDisabled: 'La edición está deshabilitada después de la fecha de la boda',
    rsvp: 'RSVP',
    music: 'Música',
    designs: 'Diseños',
    gallery: 'Galería',
    saveAsPdf: 'Guardar como PDF',
    wishlist: 'Lista de deseos',
    moneyGift: 'Regalo de Dinero',
    downloadInvitation: 'Descargar Invitación',
    weddingPlanner: 'Planificador de Bodas',
    cannotEditAfterEvent: 'No se puede editar después del evento',
    enterHashtag: 'Introducir hashtag',
    textCopied: '¡Texto copiado al portapapeles!',
    hashtagUpdated: 'Hashtag actualizado',
    activateRsvp: '¿Activar RSVP?',
    needGuestEmail: '¿Necesita el correo electrónico del invitado?',
    deleteRsvpConfirmation: '¿Eliminar a {name} de la lista de RSVP?',
    phone: 'Teléfono:',
    email: 'Correo electrónico:',
    guests: 'Invitados:',
    wishes: 'Deseos:',
    checkAttend: 'Marcar Asistencia',
    attended: 'Asistió',
    delete: 'Eliminar',
    listOfRsvps: 'Lista de RSVPs',
    searchByNameOrPhone: 'Buscar por nombre o número de teléfono',
    attending: 'Asistiendo',
    totalGuests: 'Total de invitados:',
    notAttending: 'No asistiendo',
    noRsvpsSubmitted: 'Aún no se han enviado RSVPs.',
    enableBackgroundMusic: '¿Habilitar música de fondo?',
    useThis: 'Usa esto',
    enterYoutubeLink: 'Introduce el enlace del vídeo de YouTube',
    play: 'Reproducir',
    startAt: 'Empezar en',
    ourSuggestions: 'Nuestras sugerencias:',
    aThousandYears: 'A Thousand Years',
    beautifulInWhite: 'Beautiful in White',
    perfect: 'Perfect',
    youAreTheReason: 'You Are The Reason',
    backgroundMusic: 'Música de fondo',
    copyPasteYoutubeLink: 'Copia el enlace del vídeo de YouTube y pégalo en el siguiente formulario:',
    useThisDesign: '¿Usar este diseño?',
    designUpdatedSuccessfully: 'Diseño actualizado correctamente',
    failedToUpdateDesign: 'Error al actualizar el diseño',
    errorUpdatingDesign: 'Error al actualizar el diseño',
    currentDesign: 'Diseño Actual',
    selectDesigns: 'Seleccionar Diseños',
    preview: 'Ver',
    select: 'Seleccionar',
    checkoutTitle: 'Pago',
    productSummary: 'Resumen del Producto',
    plan: 'Plan:',
    price: 'Precio:',
    billingInformation: 'Información de Facturación',
    enterYourName: 'Ingresa tu nombre',
    pleaseEnterYourName: 'Ingresa tu nombre',
    enterYourPhoneNumber: 'Ingresa tu número de teléfono',
    pleaseEnterYourPhoneNumber: 'Ingresa tu número de teléfono',
    enterYourEmail: 'Ingresa tu correo electrónico',
    promoCode: 'Código Promocional',
    enterPromoCode: 'Ingresa código promocional',
    apply: 'Aplicar',
    promoCodeAppliedSuccessfully: '¡Código promocional aplicado exitosamente!',
    promoCodeFullyClaimed: 'Este código promocional ha sido completamente reclamado. Por favor, intenta con uno diferente.',
    promoCodeExpired: 'Este código promocional ha expirado. Por favor, intenta con uno diferente.',
    invalidPromoCode: 'Código promocional inválido. Por favor, inténtalo de nuevo.',
    orderSummary: 'Resumen del Pedido',
    subtotal: 'Subtotal:',
    discount: 'Descuento:',
    total: 'Total:',
    processing: 'Procesando...',
    activate: 'Activar',
    buyNow: 'Comprar Ahora',
    failedToCreateOrder: 'Error al crear el pedido. Por favor, inténtalo de nuevo.',
    changeDesign: 'Cambiar Diseño',
    deletePhotoConfirmation: '¿Estás seguro de que quieres eliminar esta foto?',
    photoDeletedSuccessfully: 'Foto eliminada correctamente',
    errorDeletingPhoto: 'Error al eliminar la foto. Por favor, inténtalo de nuevo.',
    selectFilesFirst: 'Por favor, selecciona los archivos primero',
    cardIdNotAvailable: 'El ID de la tarjeta no está disponible',
    wpCredentialsNotConfigured: 'Las credenciales de WordPress no están configuradas',
    successfullyUploadedPhotos: '¡Se han subido {count} fotos correctamente!',
    errorUploadingPhotos: 'Error al subir las fotos. Por favor, inténtalo de nuevo.',
    photoSelected: '{count} foto seleccionada',
    photosSelected: '{count} fotos seleccionadas',
    dropPhotosHere: 'Suelta las fotos aquí o haz clic para subirlas',
    clickToUpload: 'Haz clic en el botón de abajo para empezar a subir',
    fileTypes: 'PNG, JPG, GIF de hasta 10MB',
    uploading: 'Subiendo {current}/{total} ({percent}%)',
    uploadPhotos: 'Subir Fotos',
    uploadedPhotos: 'Fotos Subidas',
    loadingPhotos: 'Cargando fotos...',
    noPhotosUploaded: 'Aún no se han subido fotos',
    deletePhoto: 'Eliminar foto',
    photoGallery: 'Galería de Fotos',
    page1: 'Página 1',
    page2: 'Página 2',
    youHaveNoAccess: 'No tienes acceso a esta página.',
    itemTitle: 'Título del Artículo',
    enterTitle: 'Introducir título',
    itemUrlOptional: 'URL del Artículo (opcional)',
    enterUrl: 'Introducir URL',
    uploadImageOptional: 'Subir Imagen (opcional)',
    saving: 'Guardando...',
    saveWishlist: 'Guardar Lista de Deseos',
    deleteItemConfirmation: '¿Estás seguro de que quieres eliminar este artículo?',
    loadingWishlist: 'Cargando lista de deseos...',
    noWishlistItems: 'Aún no se han añadido artículos a la lista de deseos.',
    clickAddWishlist: 'Haz clic en "Añadir a la Lista de Deseos" para añadir tu primer artículo.',
    title: 'Título',
    urlOptional: 'URL (opcional)',
    save: 'Guardar',
    cancel: 'Cancelar',
    viewItem: 'Ver artículo',
    myWishlist: 'Mi Lista de Deseos',
    addWishlist: 'Añadir a la Lista de Deseos',
    backToWishlist: '← Volver a la Lista de Deseos',
    deleteInfoConfirmation: '¿Estás seguro de que quieres eliminar esta información?',
    manageMoneyGift: 'Gestionar Regalo de Dinero',
    bankName: 'Nombre del Banco:',
    accountNumber: 'Número de Cuenta:',
    receiverName: 'Nombre del Receptor:',
    update: 'Actualizar',
    bankNameLabel: 'Nombre del Banco',
    bankNamePlaceholder: 'ej. Deutsche Bank, Sparkasse, N26',
    accountNumberLabel: 'Número de Cuenta',
    accountNumberPlaceholder: 'ej. IBAN: DE89 3704 0044 0532 0130 00',
    receiverNameLabel: 'Nombre del Receptor',
    receiverNamePlaceholder: 'ej. Max Mustermann',
    downloadWeddingMemories: 'Descarga tus Recuerdos de Boda',
    downloadDescription: 'Haz clic en el botón de abajo para generar y descargar tu galería de fotos y deseos de invitados en un hermoso formato PDF.',
    downloadPdf: 'Descargar PDF',
    preparing: 'Preparando...',
    photoMemories: 'Recuerdos Fotográficos',
    guestWishes: 'Deseos de Invitados',
    preparingCoverPage: 'Preparando página de portada...',
    croppingGalleryImage: 'Recortando imagen de galería {i} de {total}',
    processingWishesPage: 'Procesando página de deseos {chunkIndex} de {total}',
    finalizing: 'Finalizando...',
    done: 'Hecho',
    logout: 'Cerrar Sesión',
    yourWeddingRsvp: 'Tu RSVP de Boda',
    id: 'ID:',
    access: 'Acceder',
    editTitle: 'Editar',
    leaveWarning: '¿Estás seguro de que quieres salir? Los cambios que hiciste pueden no guardarse.',
    clickToChangeName: 'Haz clic para cambiar el nombre',
    ok: 'OK',
    changeDate: 'Cambiar fecha',
    location: 'Ubicación',
    clickToEditLocation: 'Haz clic para editar la ubicación',
    date: 'Fecha',
    time: 'Hora',
    changeTime: 'Cambiar Hora',
    schedule: 'Horario',
    newItem: 'Nuevo Elemento',
    save: 'Guardar',
    changeSchedule: 'Cambiar Horario',
    countdown: 'Cuenta Regresiva',
    days: 'Día/s',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    clickToAddContacts: 'Haz clic aquí para añadir contactos',
    clickToChangeWeddingVenue: 'Haz clic para cambiar el lugar de la boda',
    update: 'Actualizar',
    addCoordinatesFormat: 'Agregue coordenadas con el siguiente formato: 3.XXXXXX,101.XXXXXX',
    step1: 'Paso 1:',
    clickButtonToGetCoordinate: 'Haga clic en el botón de abajo para obtener la coordenada de ubicación',
    clickHere: 'Haga clic aquí',
    step2: 'Paso 2:',
    locationName: 'Nombre de ubicación:',
    locationNamePlaceholder: 'ej: Daun Grand Hall, The Icon, 6th Floor',
    coordinate: 'Coordenada:',
    coordinatePlaceholder: 'ej: 3.156525,101.722336',
    updateLocation: 'Actualizar ubicación',
    addLocation: 'Agregar ubicación',
    previewTitle: 'Vista previa',
    next: 'Siguiente',
    demoContactsMessage: 'Esto es solo un ejemplo. Haz clic en "Siguiente" para añadir contactos.',
    addContactsTitle: 'Añadir Contactos',
    addContactsDescription: 'Añade el número de contacto de tu Persona Encargada de la Boda',
    name: 'Nombre:',
    phoneNumber: 'Número de Teléfono:',
    whatsapp: 'WhatsApp',
    phoneCall: 'Llamada Telefónica',
    both: 'Ambos',
    addContact: 'Añadir Contacto',
    submit: 'Enviar',
    signUpTitle: 'Registrarse',
    confirmYourEmail: 'Confirma tu correo electrónico',
    enterOtpSentTo: 'Ingresa el OTP de 6 dígitos enviado a tu correo electrónico:',
    changeEmail: '¿Cambiar correo electrónico? Haz clic aquí',
    otp: 'OTP:',
    otpPlaceholder: 'XXXXXX',
    incorrectOtp: 'OTP incorrecto. ¡Inténtalo de nuevo!',
    confirm: 'Confirmar',
    resendOtp: 'Reenviar OTP',
    resendOtpWithCountdown: 'Reenviar OTP ({countdown})',
    signUpDescription: 'Ingresa tu dirección de correo electrónico para crear una cuenta',
    email: 'Correo electrónico',
    emailPlaceholder: 'Ingresa tu correo electrónico',
    signUpButton: 'Registrarse',
    profileTitle: 'Perfil',
    completeYourProfile: 'Completa tu perfil',
    enterYourFullName: 'Ingresa tu nombre completo',
    pleaseEnterYourFullName: 'Por favor ingresa tu nombre completo',
    pleaseEnterYourPhoneNumber: 'Por favor ingresa tu número de teléfono',
    pleaseEnterYourEmail: 'Por favor ingresa tu correo electrónico',
    submit: 'Enviar',
    selectPlanTitle: 'Seleccionar Plan',
    failedToLoadPackages: 'Error al cargar paquetes.',
    unlimitedDesigns: 'Diseños Ilimitados',
    backgroundMusic: 'Música de Fondo',
    oneClickCallWhatsapp: 'Llamada/WhatsApp con un clic',
    oneClickWazeGoogleMaps: 'Waze/Google Maps con un clic',
    countdown: 'Cuenta Regresiva',
    rsvp: 'RSVP',
    guestbook: 'Libro de Visitas',
    photoGallery: 'Galería de Fotos',
    pdf: 'PDF',
    select: 'Seleccionar',
    weInviteYou: 'Te Invitamos a Celebrar Nuestra Boda',
    tempat: 'Ubicación',
    tarikh: 'Fecha',
    masa: 'Hora',
    hari: 'Días',
    jam: 'Horas',
    minit: 'Minutos',
    saat: 'Segundos',
    selectState: 'Seleccionar Estado',
    dragMapInstruction: 'Arrastra el mapa para posicionar el pin en tu ubicación deseada',
    searchLocation: 'Buscar Ubicación',
    venueName: 'Nombre del Lugar *',
    streetAddress: 'Dirección de Calle *',
    city: 'Ciudad *',
    postcode: 'Código Postal *',
    state: 'Estado *',
    updateLocation: 'Actualizar Ubicación',
    geolocationNotSupported: 'La geolocalización no es compatible con este navegador.',
    allowLocationAccess: 'Por favor, permite el acceso a la ubicación e inténtalo de nuevo.',
    locationUnavailable: 'La información de ubicación no está disponible.',
    locationTimeout: 'La solicitud de ubicación expiró.',
    unknownError: 'Ocurrió un error desconocido.',
    googleMapsFailed: 'Google Maps falló al cargar. Por favor, refresca la página.',
    unableToFindCoordinates: 'No se pudieron encontrar las coordenadas de ubicación. Por favor, intenta una búsqueda diferente.',
    failedToInitializeSearch: 'Error al inicializar la búsqueda de ubicación. Por favor, inténtalo de nuevo.',
    loadingGoogleMaps: 'Cargando Google Maps...',
    useCurrentLocation: 'Usar mi ubicación actual',
    enterVenueName: 'Ingresa el nombre del lugar',
    enterStreetAddress: 'Ingresa tu dirección de calle',
    cityPlaceholder: 'Ciudad',
    postcodePlaceholder: '12345',
    malaysia: 'Malasia',
    currentLocationPrefix: 'Ubicación Actual: ',
    selectedLocationPrefix: 'Ubicación Seleccionada: ',
    unableToGetCurrentLocation: 'No se pudo obtener tu ubicación actual. ',
    money_gift: 'Regalo de Dinero',
    wishlist: 'Lista de Deseos',
    download: 'Descargar',
    planner: 'Planificador',
  },
};

export default translations;
